import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { saveAs } from "file-saver";
import { NavService } from 'src/app/services/nav.service';
import { LabelPreparationService } from 'src/app/services/settings/labelpreparation.service';
import { AsyncModalService } from 'src/app/services/shared/async-modal-service';

@Component({
    standalone: false,
    selector: 'app-labelpreparation-export',
    templateUrl: './label-preparation.export.component.html',
    styleUrls: ['./label-preparation.export.component.css']
})
export class LabelPreparationExportComponent {
    @ViewChild("labelPreparationExportModalCloseButton") public labelPreparationExportModalCloseButton: ElementRef;

    labelPreparationExportEntryIds: number[];
    labelPreparationEntryNumber: number;
    labelPreparationSetupName: string;
    formName: string;


    constructor(
        private route: ActivatedRoute,
        private labelPreparationService: LabelPreparationService,
        private asyncModalService: AsyncModalService,
        private navService: NavService
    ) {
    }

    ngOnInit() {
        this.labelPreparationExportEntryIds = [];
    }

    async download(fileExtension) {
        let payload = {
            exportEntryIds: this.labelPreparationExportEntryIds,
            fileExtension: fileExtension,
            isCreateTypeQRCode: false,
            fcEntryNumber: +this.route.snapshot.params.formId,
            accessNbr: this.route.snapshot.data["accessNbr"] ?? 0,
            routeUrl: this.route.snapshot["_routerState"].url
        }

        this.labelPreparationExportModalCloseButton.nativeElement.click();
        this.labelPreparationService.export(payload, this.labelPreparationEntryNumber).subscribe(
            (blob) => {
                let currentDate = new DatePipe("en-US").transform(new Date(), "yyyyMMdd");
                let fileName =
                    currentDate + " " +
                    (this.navService.menu?.summary != null ? this.navService.menu.summary.name + " " : "") +
                    this.formName + " " +
                    this.labelPreparationSetupName + ".csv"
                saveAs(blob, fileName);
            },
            async (err) => {
                var reader = new FileReader();
                var vm = this;
                reader.onloadend = function (e) {
                    if (err.status == 400) {
                        vm.asyncModalService.getModalResponse((<any>e.target).result);
                    }
                    else {
                        vm.asyncModalService.getModalResponse(
                            "An error occurred performing your download request, \
                            this could be due to a slow internet connection, can you \
                            please try again when your connection improves or if the issue \
                            persists can you please reduce the number of entries to be \
                            downloaded and then try again"
                        );
                    }
                }
                reader.readAsText(err.error);
            },
            () => {
                this.labelPreparationExportModalCloseButton.nativeElement.click();
            }
        )
    }

    delay(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
}

